export default "__VITE_ASSET__DAQwPNdb__"